import { type AnyRouter, RouterProvider } from '@tanstack/react-router';
import { useEffect } from 'react';

import { captureException } from './logger/capture-exception';
import { trackError } from './error/tracking';
import { getQueryClient } from './sdk/request';
import { getStores } from './services/storage';
import { fetchAuthUserImperative, getAuthUserFromCache } from './services/storage/users-queries';
import { useToast } from './shared/contexts/toast-context';

export function AppRouterUnauth(props: { router: AnyRouter }) {
  const addToast = useToast();

  // auth cant go through without data required like for example auth, org, brand...
  useEffect(function() {
    // remove the loading screen, not required at this point by unauth
    const loadingScreen = document.querySelector('#loading-screen');
    if (loadingScreen != null) {
      loadingScreen.remove();
    }

    const queryClient = getQueryClient();

    Promise.resolve(getStores().users.getState().getAuthToken())
      .then(function(token) {
        if (token == null || token.length === 0) {
          return;
        }

        // Use TanStack Query to fetch and cache auth user
        return fetchAuthUserImperative(queryClient).catch(() => undefined);
      })
      .then(function() {
        // Check TanStack Query cache for auth user
        const authUser = getAuthUserFromCache(queryClient);
        if (authUser == null) {
          return;
        }

        // already have an user so just redirect him
        // NOTE: we want to use the window location so it completely refreshes
        window.location.href = '/app';
      })
      .catch(function(err) {
        captureException(
          err,
          {
            file: 'router-unauth.tsx',
            method: 'allSettled',
            infoMessage: 'unable to manage requirements',
          },
          trackError,
          addToast,
        );
      });
  });

  return <RouterProvider router={props.router} notFoundMode="root" />;
}
